import { render, staticRenderFns } from "./TbColumns.vue?vue&type=template&id=41e42ee8"
import script from "./TbColumns.vue?vue&type=script&lang=js"
export * from "./TbColumns.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports